export const USER = 'USER';
